import { useState, useContext } from 'react';

import { AppContext } from 'commons-ui';
import { isNil } from 'lodash';
import { ContentPropsT, InvoiceFilters } from '../constants';

const useFilter = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const { tournamentID, dateRange, gameName, userId, invoiceType } = submittedData;
			let filterData: InvoiceFilters = { userId, gameName, invoiceType, tournamentID };

			if (!isNil(dateRange) && dateRange.length === 2) {
				filterData = {
					...filterData,
					dateRangeFrom: dateRange[0].getTime(),
					dateRangeTill: dateRange[1].getTime() + 86400000
				};
			}
			handleFilterSubmit(filterData);
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in fetching invoice data', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = () => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useFilter;
